<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "config-postSelect",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

